import React from "react";
import PropTypes from "prop-types";
import { Message } from "wvus-forms";
import { getPhrase, Say } from "../../languages";

class SelectControl extends React.Component {
  constructor(props) {
    super(props);
    const {
      fieldName,
      fieldValue = "",
      secondInteraction = false,
      isValid = false,
      validators = [],
      optional = false,
      formMethods
    } = this.props;
    formMethods.addFieldToState(
      fieldName,
      fieldValue,
      secondInteraction,
      isValid,
      validators,
      optional
    );
  }

  render() {
    const {
      formMethods,

      fieldOptions,
      fieldName,
      fieldClasses = "",
      fieldTitlePhraseKey,
      attributes = {},

      fieldState = formMethods.getFieldState(fieldName),
      inputClasses = "",
      labelClasses = "",

      handleValueChange = formMethods.handleValueChange,
      handleBlur = formMethods.handleBlur,
      handleFocus = () => {},
      showUISuccess = formMethods.showUISuccess(fieldState),
      showUIError = formMethods.showUIError(fieldState),
      hideMessage = false,
      successIcon,
      errorIcon
    } = this.props;
    const disabled = attributes.disabled ? attributes.disabled : false;

    const options = fieldOptions.map((option, index) => (
      <option key={index} value={option.valueKey}>
        {index === 0
          ? `▾ ${getPhrase(fieldTitlePhraseKey)}${!fieldState.optional && " *"}`
          : option.valueText}
      </option>
    ));

    const validityClass = showUISuccess ? "has-success " : showUIError ? "has-error " : "";
    const fieldValue = fieldState.value || "";
    const fieldPrimaryClass = `wvus-field-${fieldName}`;

    return (
      <div className={`${fieldPrimaryClass} ${fieldClasses} form-group has-icon ${validityClass}`}>
        <label htmlFor={fieldName} className={labelClasses}>
          <Say phrase={fieldTitlePhraseKey} /> {fieldState.optional ? "" : <sup>*</sup>}
        </label>
        <div className="form-control-wrapper">
          <select
            id={fieldName}
            className={`form-control select-control ${inputClasses}`}
            value={fieldValue}
            name={fieldName}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onChange={handleValueChange}
            disabled={disabled}
            data-phrase-key={fieldTitlePhraseKey}>
            {options}
          </select>
          {showUIError ? (
            <Message
              showError={true}
              showSuccess={false}
              message={fieldState.errorMessage}
              errorIcon={errorIcon}
              hideMessage={hideMessage}
            />
          ) : (
            ""
          )}
          {showUISuccess ? (
            <Message
              showError={false}
              showSuccess={true}
              successIcon={successIcon}
              hideMessage={hideMessage}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

SelectControl.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldOptions: PropTypes.array.isRequired,
  formMethods: PropTypes.shape({
    handleBlur: PropTypes.func.isRequired,
    handleValueChange: PropTypes.func.isRequired,
    getFieldState: PropTypes.func.isRequired,
    showUIError: PropTypes.func.isRequired,
    showUISuccess: PropTypes.func.isRequired
  }).isRequired,
  validators: PropTypes.array
};

export default SelectControl;
